import { Star, Facebook, ThumbsUp, ThumbsDown } from "lucide-react";
import { typeLabel } from "@/lib/api";

export const Stars = ({ n, size = 14 }) => (
  <div className="flex gap-1.5 text-oro" data-testid="review-rating">
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={size} fill={i <= n ? "currentColor" : "none"} strokeWidth={1.2} />)}
  </div>
);

const SOURCE_LABEL = { google: "Google", facebook: "", sito: "" };

/** Facebook non ha stelle: mostra "Consigliato / Non consigliato". */
export const Rating = ({ r, size = 14 }) => {
  if (r.source === "facebook") return (
    <span className={`inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.12em] ${r.recommended === false ? "text-mute" : "text-oliva"}`} data-testid="review-recommended">
      <Facebook size={size} strokeWidth={1.4} />
      {r.recommended === false ? <><ThumbsDown size={size - 2} strokeWidth={1.5} /> Non consigliato</> : <><ThumbsUp size={size - 2} strokeWidth={1.5} /> Consigliato</>}
    </span>
  );
  if (!r.rating) return null;
  return <Stars n={r.rating} size={size} />;
};

export const ReviewQuote = ({ r, i, large }) => (
  <figure className="border-t border-oro/40 pt-9" data-testid={`review-card-${i}`}>
    <div className="mb-6"><Rating r={r} size={large ? 16 : 14} /></div>
    <blockquote className={`font-serif font-light italic text-ink leading-[1.32] tracking-[-0.015em] ${large ? "text-3xl sm:text-[42px]" : "text-[23px]"}`}>{r.text}</blockquote>
    <figcaption className="mt-8 flex flex-wrap items-center gap-5 text-[12.5px] uppercase tracking-[0.14em]">
      <span className="text-ink">{r.author}</span>
      <span className="w-8 h-px bg-oro" />
      <span className="text-mute normal-case tracking-normal text-[13px]">{typeLabel(r.event_type)}</span>
      {SOURCE_LABEL[r.source] && <span className="text-mute text-[11px]" data-testid="review-source">via {SOURCE_LABEL[r.source]}</span>}
    </figcaption>
  </figure>
);
